import moment from "moment-timezone";

const numericFields = [
  'qtd_imoveis_conectados_nap', 
  'qtd_saidas_nap', 
  'quantidade_andar', 
  'quantidade_ap_por_andar', 
  'quantidade_bloco', 
];

function createJsonSpecialCodes(contract) {
  let OsRequestContract = {
    accredited: contract.accredited,
    numberPhone: contract.numberPhone,
    codeCity: contract.city.value,
    initialTime: contract.initialTime,
    conclusionTime: contract.conclusionTime,
    contractNumber: contract.contractNumber !== "" ? contract.contractNumber : "0",
    typeAttendance: contract.typeAttendance ?? 2,
    serviceOutsideToa: contract.serviceOutsideToa ?? 0,
    dateStartedAttendance: contract.dateStartedAttendance ?? "",
    dateFinishedAttendance: moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss"),
    numberWo: contract.numberWo ?? "",
    urlLink: contract.urlLink ?? "",
    isOwnTechnician: contract.isOwnTechnician ?? false,
    technicianCode: contract.technicianCode ?? "",
    accreditedCode: contract.accreditedCode ?? "",
    osRequests: contract.solicitations.map((item) => {
      if (Object.keys(item).includes("typeOS") && item.typeOS != null) {
        item.typeOS = item.typeOS.value;
      }

      if (
        Object.keys(item).includes("writeOffCode") &&
        item.writeOffCode != null
      ) {
        item.writeOffCode = item.writeOffCode.value;
      }

      Object.keys(item)
        .filter((key) => numericFields.includes(key))
        .forEach((key) => {
          const numValue = Number(item[key]);
          if (!isNaN(numValue)) {
            item[key] = numValue;
          }
        });

      return item;
    }),
  };
  return OsRequestContract
}
export default createJsonSpecialCodes;
